










































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class SuccessFeedback extends Vue {
  @Prop({ default: '80' }) readonly width?: string;
  @Prop({ default: '80' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly color?: string;
  @Prop({ default: '#2600FF' }) readonly colorBackground?: string;
  @Prop({ default: false }) readonly isGradient?: boolean;
}
